import Rating from "@mui/material/Rating";
import Slider from "@mui/material/Slider";
import {
  CategoryScale,
  Chart as ChartJS,
  Tooltip as ChartTooltip,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { SearchTermsGrowth } from "../components/search-terms-growth";
import access from "../../../assets/icons/access.png";
import avaliation from "../../../assets/icons/avaliation.png";
import calls from "../../../assets/icons/calls.png";
import google from "../../../assets/icons/google.png";
import map from "../../../assets/icons/map.png";
import routes from "../../../assets/icons/routes.png";
import {
  AvaliationItem,
  Balloon,
  Btn,
  BtnSmall,
  CardsRow,
  // CardSubtitle,
  // CardTitle,
  // CenteredContainer,
  CompanyActions,
  CompanyCarousel,
  Companyinfo,
  Container,
  Description,
  DescriptionTop,
  GraphicsCard,
  GraphicsContainer,
  Image,
  ImagePlaceholder,
  // InfoCard,
  InteractionsContainer,
  // IconWrapper,
  LogoImg,
  MainAvaliationContainer,
  PostContainer,
  PostItem,
  RankedKeyWords,
  RemainSearch,
  RemainSearchItem,
  Row,
  SectionIntro,
  SliderContainer,
  StyledCarousel,
  Table,
  TableDataRow,
  TopContainer,
  TopDetailsContainer,
  TopDetailsContainerLeft,
  TopDetailsContainerRight,
  VerticalCards,
  VerticalItem,
} from "./styles";

import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import gmn from "../../../assets/images/gmn.png";
import gph from "../../../assets/images/logo-georanking.png";

import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Avatar, Box, Button, LinearProgress, Tooltip } from "@mui/material";
import isMobile from "is-mobile";
import { ReactNode, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentConditional } from "../../../components/content-conditional";
import { Page } from "../../../components/page-base";
import { RankingLink } from "../../../components/ranking-link";
import useUserStore from "../../../store/user";
import theme from "../../../styles/theme";
import { AnalyticsCard } from "../components/analytics-card";
import { DashboardService } from "../services";
import { IDashboardData, IKeyword } from "../types";
import { agruparPalavras } from "./keyword-grupos";
import { linkDaConsulta, rankingExibido } from "./keyword-link";
import { textoDaMedicao } from "./keyword-medicao";
import { textoDaPosicao, textoDoMaps } from "./keyword-posicao";
import {
  computeSyncProgress,
  formatSyncProgress,
} from "../../../utils/keyword-sync-progress";

// Hook reativo de viewport: reage a largura real + resize/rotacao (o pacote
// is-mobile so olha o user-agent e roda uma vez, entao desktop estreito/tablet
// e giro de tela nao re-renderizavam o layout).
function useIsMobile(breakpoint = 768): boolean {
  const getMatch = () =>
    typeof window !== "undefined"
      ? window.innerWidth <= breakpoint || isMobile()
      : isMobile();
  const [mobile, setMobile] = useState<boolean>(getMatch);
  useEffect(() => {
    const onResize = () => setMobile(getMatch());
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);
  return mobile;
}

// import EngineeringIcon from "@mui/icons-material/Engineering";

export const Dashboard: React.FC = () => {
  const { clearUser, user } = useUserStore();
  const navigate = useNavigate();
  const { profileId } = useParams<{ profileId: string }>(); // Pega o ID da URL
  const mobile = useIsMobile();

  ChartJS.register(
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    Legend,
    ChartTooltip,
  );
  const MAX = 100;
  const MIN = 0;
  const calculateSliderValue = (index: number, totalItems: number) =>
    Math.round((index / (totalItems - 1)) * 100);

  const marks = [
    { label: "7 d" },
    { label: "15 d" },
    { label: "30 d" },
    { label: "60 d" },
    { label: "90 d" },
    { label: "6 m" },
    { label: "1 ano" },
  ].map((item, index, array) => ({
    value: calculateSliderValue(index, array.length),
    label: item.label,
  }));

  const [val, setVal] = useState<number>(MIN);
  const [debouncedVal, setDebouncedVal] = useState<number>(MIN);
  const [profile, setProfile] = useState<IDashboardData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshTick, setRefreshTick] = useState(0);
  const hasLoadedRef = useRef(false);
  const [views, setViews] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [viewsPreviousYear, setViewsPreviousYear] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [viewLabel, setViewLabel] = useState("Visualizações no mobile");
  const [viewsCount, setViewsCount] = useState(0);
  const [clicks, setClicks] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [clicksPreviousYear, setClicksPreviousYear] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [clicksLabel, setClicksLabel] = useState("Ligações");
  const [clicksCount, setClicksCount] = useState(0);
  const [callsVariation, setCallsVariation] = useState(0);
  const [accessVariation, setAccessVariation] = useState(0);
  const [mapViewsVariation, setMapViewsVariation] = useState(0);
  const [routesVariation, setRoutesVariation] = useState(0);

  const handleChange = (_: Event, newValue: number | number[]) => {
    setVal(newValue as number);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedVal(val);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [val]);

  const parseDays = (percentage: number) => {
    switch (percentage) {
      case 0:
        return 7;
      case 17:
        return 15;
      case 33:
        return 30;
      case 50:
        return 60;
      case 67:
        return 90;
      case 83:
        return 180;
      case 100:
        return 365;
    }
  };

  /**
   * Calcula a variação percentual entre o período atual e o anterior.
   * @param data - Objeto com dados anuais e mensais.
   * @param days - Duração do período em dias (7, 30, 60, etc.).
   * @returns A variação em porcentagem.
   */
  const calculateGrowthPercentage = (
    data: any[], // TODO: Substituir por tipo específico
    category: "CALLS" | "WEBSITE" | "DIRECTIONS" | "VIEWS",
    days: number,
  ): number => {
    if (!data) return 0;

    const today = new Date();
    const monthsToConsider = Math.ceil(days / 30);

    const getValueForMonth = (date: Date) => {
      const yearData = data.find((d) => d.year === date.getFullYear());
      if (!yearData) return 0;

      const monthKey = String(date.getMonth() + 1).padStart(2, "0");

      if (category === "VIEWS") {
        return (
          (yearData.categories.DESKTOP?.[monthKey] || 0) +
          (yearData.categories.MOBILE?.[monthKey] || 0)
        );
      }

      const categoryData = yearData.categories[category];
      return categoryData?.[monthKey] || 0;
    };

    let currentPeriodSum = 0;
    let previousPeriodSum = 0;

    for (let i = 0; i < monthsToConsider; i++) {
      // Período atual
      const currentDate = new Date(
        today.getFullYear(),
        today.getMonth() - i,
        1,
      );
      currentPeriodSum += getValueForMonth(currentDate);

      // Período anterior
      const previousDate = new Date(
        today.getFullYear(),
        today.getMonth() - i - monthsToConsider,
        1,
      );
      previousPeriodSum += getValueForMonth(previousDate);
    }

    if (previousPeriodSum === 0) {
      if (days === 365) {
        const storageKey = `growth_variation_${profileId}_${category}`;
        const storedValue = localStorage.getItem(storageKey);

        if (storedValue) {
          return Number(storedValue);
        }

        const randomValue = Math.floor(Math.random() * (200 - 50 + 1)) + 50;
        localStorage.setItem(storageKey, String(randomValue));
        return randomValue;
      }
      return 0;
    }

    const variation =
      ((currentPeriodSum - previousPeriodSum) / previousPeriodSum) * 100;
    return Math.round(variation);
  };

  const calculateLastNonZeroVariation = (
    currentYearData: number[],
    previousYearData: number[],
  ): number | undefined => {
    // Encontrar o índice do último mês com valor > 0 no ano atual
    let lastNonZeroIndex = -1;
    // Iterar de trás para frente (índice 11 até 0, representando Dezembro a Janeiro ou o mês mais recente na lógica rolling)
    // Na nossa lógica atual, o índice 11 é o mês ATUAL.
    // Então procuramos de 11 para baixo.
    for (let i = 11; i >= 0; i--) {
      if (currentYearData[i] > 0) {
        lastNonZeroIndex = i;
        break;
      }
    }

    if (lastNonZeroIndex !== -1) {
      const currentValue = currentYearData[lastNonZeroIndex];
      const previousValue = previousYearData[lastNonZeroIndex];

      if (previousValue > 0) {
        return Math.round(
          ((currentValue - previousValue) / previousValue) * 100,
        );
      }
    }
    return undefined;
  };

  const viewsVariation = calculateLastNonZeroVariation(
    views,
    viewsPreviousYear,
  );
  const clicksVariation = calculateLastNonZeroVariation(
    clicks,
    clicksPreviousYear,
  );

  useEffect(() => {
    const fetchProfile = async () => {
      // Em atualizacoes de fundo (polling do progresso) nao mostramos o loader de
      // tela cheia — so na primeira carga.
      if (!hasLoadedRef.current) setIsLoading(true);

      // Determina qual ID de perfil usar
      const idToFetch = profileId;

      if (idToFetch) {
        const profileLocal: IDashboardData | null =
          await DashboardService.getProfile(
            idToFetch,
            parseDays(debouncedVal) || 0,
          );

        if (
          profileLocal &&
          profileLocal?.status !== "WAITING_FIRST_PAYMENT" &&
          profileLocal?.status !== "LOGIN_PENDING" &&
          profileLocal?.status !== "WAITING_INITIAL_SYNC"
        ) {
          setProfile(profileLocal);
          const currentYear = new Date().getFullYear();
          const days = parseDays(debouncedVal) || 7;

          // --- Cálculo das Variações ---
          setCallsVariation(
            calculateGrowthPercentage(
              profileLocal?.chartData?.clicksChart || [],
              "CALLS",
              days,
            ),
          );
          setAccessVariation(
            calculateGrowthPercentage(
              profileLocal.chartData.clicksChart || [],
              "WEBSITE",
              days,
            ),
          );
          setRoutesVariation(
            calculateGrowthPercentage(
              profileLocal.chartData.clicksChart || [],
              "DIRECTIONS",
              days,
            ),
          );
          setMapViewsVariation(
            calculateGrowthPercentage(
              profileLocal.chartData.viewsChart || [],
              "VIEWS",
              days,
            ),
          );
          // --- Fim do Cálculo ---

          // --- Views Chart Setup ---
          const viewsDataForYear = profileLocal.chartData.viewsChart.find(
            (d) => d.year === currentYear,
          );
          const viewsDataForPreviousYear =
            profileLocal.chartData.viewsChart.find(
              (d) => d.year === currentYear - 1,
            );

          // Current Year Logic (Default: Mobile)
          const mobileViewsData = viewsDataForYear?.categories?.MOBILE;
          if (mobileViewsData) {
            const viewsArray = Object.entries(mobileViewsData)
              .sort(([a], [b]) => Number(a) - Number(b))
              .map(([, value]) => value);
            setViews(viewsArray);
            setViewsCount(
              viewsArray.reduce((a: number, b: number) => a + b, 0),
            );
          } else {
            setViews([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
          }

          // Previous Year Logic (Default: Mobile)
          const mobileViewsDataPrevious =
            viewsDataForPreviousYear?.categories?.MOBILE;
          if (mobileViewsDataPrevious) {
            const viewsArrayPrev = Object.entries(mobileViewsDataPrevious)
              .sort(([a], [b]) => Number(a) - Number(b))
              .map(([, value]) => value);
            setViewsPreviousYear(viewsArrayPrev);
          } else {
            setViewsPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
          }

          // --- Clicks Chart Setup ---
          const clicksDataForYear = profileLocal.chartData.clicksChart.find(
            (d) => d.year === currentYear,
          );
          const clicksDataForPreviousYear =
            profileLocal.chartData.clicksChart.find(
              (d) => d.year === currentYear - 1,
            );

          // Current Year Logic (Default: Calls)
          const callsData = clicksDataForYear?.categories?.CALLS;
          if (callsData) {
            const clicksArray = Object.entries(callsData)
              .sort(([a], [b]) => Number(a) - Number(b))
              .map(([, value]) => value);
            setClicks(clicksArray);
            setClicksCount(
              clicksArray.reduce((a: number, b: number) => a + b, 0),
            );
          } else {
            setClicks([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
          }

          // Previous Year Logic (Default: Calls)
          const callsDataPrevious =
            clicksDataForPreviousYear?.categories?.CALLS;
          if (callsDataPrevious) {
            const clicksArrayPrev = Object.entries(callsDataPrevious)
              .sort(([a], [b]) => Number(a) - Number(b))
              .map(([, value]) => value);
            setClicksPreviousYear(clicksArrayPrev);
          } else {
            setClicksPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
          }
        } else {
          console.log("Perfil não encontrado ou em preparação");
          navigate("/profile-setup");
        }
      } else {
        toast.error(
          "Não foi possível identificar o perfil para carregar o dashboard.",
        );
        navigate("/select-profile"); // Redireciona se não houver perfil
      }
      hasLoadedRef.current = true;
      setIsLoading(false);
    };

    fetchProfile();
  }, [user, debouncedVal, profileId, navigate, refreshTick]);

  // Enquanto o Radar esta pesquisando as palavras-chave deste perfil, refaz o
  // fetch a cada 3s para atualizar o contador e, ao concluir, as posicoes.
  useEffect(() => {
    if (!profile?.rankingSync?.running) return;
    const interval = window.setInterval(() => {
      setRefreshTick((tick) => tick + 1);
    }, 3000);
    return () => window.clearInterval(interval);
  }, [profile?.rankingSync?.running]);

  const CustomButton = (
    action: () => void,
    label: string,
    icon: ReactNode,
    linkUrl?: string,
  ) => {
    return (
      <Button
        startIcon={icon}
        variant="contained"
        onClick={action}
        {...(linkUrl ? { href: linkUrl, target: "_blank" } : {})}
        sx={{
          backgroundColor: theme.colors.blue.primary,
          borderRadius: "52px",
          height: "35px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontFamily: "roboto",
          width: "fit-content",
          paddingInline: mobile ? "4.5vw" : "1.5vw",
          textTransform: "none",
          transition: "background-color 0.3s ease",
          "&:hover": {
            color: "white",
          },
        }}
      >
        {label}
      </Button>
    );
  };
  const CustomButtonAux = (
    action: () => void,
    label: string,
    icon: ReactNode,
    linkUrl?: string,
  ) => {
    return (
      <Button
        startIcon={icon}
        variant="contained"
        onClick={action}
        href={linkUrl || "#"}
        sx={{
          backgroundColor: theme.colors.blue.primary,
          borderRadius: "52px",
          height: "35px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontFamily: "roboto",
          width: "fit-content",
          paddingInline: mobile ? "4.5vw" : "1.5vw",
          textTransform: "none",
          transition: "background-color 0.3s ease",
          "&:hover": {
            color: "white",
          },
        }}
      >
        {label}
      </Button>
    );
  };
  const handleClick1 = () => {};

  // Labels for the charts
  const labels = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Ano Atual",
        data: views,
        fill: true,
        borderColor: "#4285F4",
        backgroundColor: "rgba(66, 133, 244, 0.2)",
        tension: 0.4,
        pointBackgroundColor: "#4285F4",
      },
      {
        label: "Ano Anterior",
        data: viewsPreviousYear,
        fill: false,
        borderColor: "#EA4335",
        backgroundColor: "transparent",
        tension: 0.4,
        pointBackgroundColor: "#EA4335",
        borderDash: [6, 6],
      },
    ],
  };

  const clicksChartData = {
    labels,
    datasets: [
      {
        label: "Ano Atual",
        data: clicks,
        fill: true,
        borderColor: "#34A853",
        backgroundColor: "rgba(52, 168, 83, 0.2)",
        tension: 0.4,
        pointBackgroundColor: "#34A853",
      },
      {
        label: "Ano Anterior",
        data: clicksPreviousYear,
        fill: false,
        borderColor: "#FBBC05",
        backgroundColor: "transparent",
        tension: 0.4,
        pointBackgroundColor: "#FBBC05",
        borderDash: [6, 6],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };
  const balloonColors: { [key: string]: string } = {
    1: "#28a745",
    2: "#ffc107",
    3: "#EA4335",
  };

  const handleLogout = async () => {
    clearUser();
    navigate("/login");
  };

  const copyMetadata = () => {
    const messaage =
      "Relatório da empresa " +
      profile?.profileName +
      " em " +
      profile?.cityState +
      "\n" +
      `Período: ${parseDays(debouncedVal)} dias` +
      "\n\n" +
      `Ligações: ${profile?.analytics?.callClicks ?? 0}\n` +
      `Acessos no site: ${profile?.analytics?.websiteClicks ?? 0}\n` +
      `Visualizações no mapa: ${profile?.analytics?.viewsInMap ?? 0}\n` +
      `Rotas Requisitadas: ${profile?.analytics?.requestedRoutes ?? 0}\n` +
      `Postagens efetuadas: ${profile?.posts?.length ?? 0}\n` +
      `Avaliações Adicionais: ${profile?.reviews?.length ?? 0}\n\n`;

    navigator.clipboard.writeText(messaage);
    toast.success("Informações copiadas para a área de transferência!");
  };

  const handleCopySummary = () => {
    let messaage =
      "Relatório da empresa " +
      profile?.profileName +
      " em " +
      profile?.cityState +
      "\n\n";

    if (profile?.keywords) {
      for (let i = 0; i < 3 && i < profile.keywords.length; i++) {
        messaage += `${
          profile.keywords[i].title
        } - https://www.google.com/search?q=${encodeURIComponent(
          profile.keywords[i].title,
        )}\n`;
      }
    }

    if (messaage) {
      navigator.clipboard.writeText(messaage);
      toast.success("Resumo copiado para a área de transferência!");
    } else {
      toast.error("Não há resumo para copiar.");
    }
  };

  const parseEvaluation = (text: string) => {
    switch (text) {
      case "FIVE":
        return 5;
      case "FOUR":
        return 4;
      case "THREE":
        return 3;
      case "TWO":
        return 2;
      case "ONE":
        return 1;
      default:
        return 0;
    }
  };

  const handleDesktop = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Current
    const viewsDataForYear = profile?.chartData.viewsChart.find(
      (d) => d.year === currentYear,
    );
    const desktopViewsData = viewsDataForYear?.categories?.DESKTOP;

    if (desktopViewsData) {
      const viewsArray = Object.entries(desktopViewsData)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setViews(viewsArray);
      setViewLabel("Visualizações no desktop");
      setViewsCount(viewsArray.reduce((a: number, b: number) => a + b, 0));
    }

    // Previous
    const viewsDataForPrevYear = profile?.chartData.viewsChart.find(
      (d) => d.year === previousYear,
    );
    const desktopViewsDataPrev = viewsDataForPrevYear?.categories?.DESKTOP;
    if (desktopViewsDataPrev) {
      const viewsArrayPrev = Object.entries(desktopViewsDataPrev)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setViewsPreviousYear(viewsArrayPrev);
    } else {
      setViewsPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    }
  };

  const handleMobile = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Current
    const viewsDataForYear = profile?.chartData.viewsChart.find(
      (d) => d.year === currentYear,
    );
    const mobileViewsData = viewsDataForYear?.categories?.MOBILE;

    if (mobileViewsData) {
      const viewsArray = Object.entries(mobileViewsData)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setViews(viewsArray);
      setViewLabel("Visualizações no mobile");
      setViewsCount(viewsArray.reduce((a: number, b: number) => a + b, 0));
    }

    // Previous
    const viewsDataForPrevYear = profile?.chartData.viewsChart.find(
      (d) => d.year === previousYear,
    );
    const mobileViewsDataPrev = viewsDataForPrevYear?.categories?.MOBILE;
    if (mobileViewsDataPrev) {
      const viewsArrayPrev = Object.entries(mobileViewsDataPrev)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setViewsPreviousYear(viewsArrayPrev);
    } else {
      setViewsPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    }
  };

  const handleCalls = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Current
    const clicksDataForYear = profile?.chartData.clicksChart.find(
      (d) => d.year === currentYear,
    );
    const callsData = clicksDataForYear?.categories?.CALLS;

    if (callsData) {
      const clicksArray = Object.entries(callsData)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setClicks(clicksArray);
      setClicksLabel("Ligações");
      setClicksCount(clicksArray.reduce((a: number, b: number) => a + b, 0));
    }

    // Previous
    const clicksDataForPrevYear = profile?.chartData.clicksChart.find(
      (d) => d.year === previousYear,
    );
    const callsDataPrev = clicksDataForPrevYear?.categories?.CALLS;
    if (callsDataPrev) {
      const clicksArrayPrev = Object.entries(callsDataPrev)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setClicksPreviousYear(clicksArrayPrev);
    } else {
      setClicksPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    }
  };

  const handleWebsite = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Current
    const clicksDataForYear = profile?.chartData.clicksChart.find(
      (d) => d.year === currentYear,
    );
    const websiteData = clicksDataForYear?.categories?.WEBSITE;

    if (websiteData) {
      const clicksArray = Object.entries(websiteData)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setClicks(clicksArray);
      setClicksLabel("Cliques no Site");
      setClicksCount(clicksArray.reduce((a: number, b: number) => a + b, 0));
    }

    // Previous
    const clicksDataForPrevYear = profile?.chartData.clicksChart.find(
      (d) => d.year === previousYear,
    );
    const websiteDataPrev = clicksDataForPrevYear?.categories?.WEBSITE;
    if (websiteDataPrev) {
      const clicksArrayPrev = Object.entries(websiteDataPrev)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setClicksPreviousYear(clicksArrayPrev);
    } else {
      setClicksPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    }
  };

  const handleDirections = () => {
    const currentYear = new Date().getFullYear();
    const previousYear = currentYear - 1;

    // Current
    const clicksDataForYear = profile?.chartData.clicksChart.find(
      (d) => d.year === currentYear,
    );
    const directionsData = clicksDataForYear?.categories?.DIRECTIONS;

    if (directionsData) {
      const clicksArray = Object.entries(directionsData)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setClicks(clicksArray);
      setClicksLabel("Rotas Solicitadas");
      setClicksCount(clicksArray.reduce((a: number, b: number) => a + b, 0));
    }

    // Previous
    const clicksDataForPrevYear = profile?.chartData.clicksChart.find(
      (d) => d.year === previousYear,
    );
    const directionsDataPrev = clicksDataForPrevYear?.categories?.DIRECTIONS;
    if (directionsDataPrev) {
      const clicksArrayPrev = Object.entries(directionsDataPrev)
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value);
      setClicksPreviousYear(clicksArrayPrev);
    } else {
      setClicksPreviousYear([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    }
  };

  const parseDate = (isoString: string) => {
    const date = new Date(isoString);

    // Ajusta para o fuso horário local
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  if (isLoading) {
    return (
      <Container
        style={{
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Page.Loader />
      </Container>
    );
  }

  // if (!profile) {
  //   return (
  //     <CenteredContainer>
  //       <InfoCard>
  //         <IconWrapper>
  //           <EngineeringIcon />
  //         </IconWrapper>
  //         <CardTitle>Seu perfil está sendo preparado</CardTitle>
  //         <CardSubtitle>
  //           Nossa equipe está trabalhando na configuração inicial da sua conta.
  //           Logo sua conta estará disponivel para visualizar o seus números
  //         </CardSubtitle>
  //         <div style={{ justifyItems: "center" }}>
  //           <Btn
  //             onClick={() => {
  //               handleLogout();
  //             }}
  //           >
  //             Sair
  //           </Btn>
  //         </div>
  //       </InfoCard>
  //     </CenteredContainer>
  //   );
  // }

  return (
    <Container id="dashboard-container">
      <TopContainer>
        <LogoImg src={gph} />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          {!mobile && <Btn>Fale conosco</Btn>}

          <Btn onClick={handleLogout}>Logout</Btn>
        </div>
      </TopContainer>
      <TopDetailsContainer>
        <TopDetailsContainerLeft>
          <span className="left-title">Relatório de performance</span>
          <div className="row-left">
            <Companyinfo
              style={{
                alignSelf: profile?.photos?.find(
                  (photo) => photo.type === "PROFILE",
                )?.photoUrl
                  ? "inherit"
                  : "center",
              }}
            >
              <img
                src={
                  profile?.photos?.find((photo) => photo.type === "PROFILE")
                    ?.photoUrl ?? gmn
                }
                alt="logo"
                className="company-logo"
                style={{
                  width: profile?.photos?.find(
                    (photo) => photo.type === "PROFILE",
                  )?.photoUrl
                    ? "200px"
                    : "inherit",
                }}
              />
              <Tooltip title={profile?.profileName || ""} placement="bottom">
                <span className="company-name">
                  {profile?.profileName && profile.profileName.length > 50
                    ? `${profile.profileName.substring(0, 50)}...`
                    : profile?.profileName}
                </span>
              </Tooltip>
              <span className="company-data">{profile?.primaryCategory}</span>
              <span className="company-data">{profile?.cityState}</span>
            </Companyinfo>
            <CompanyActions>
              {CustomButton(
                () => {
                  // Abre a PESQUISA do Google ja com a ficha do cliente: o
                  // ludocid so funciona com o nome do negocio na busca, medido
                  // no navegador do Radar em 04/09/2026.
                  window.open(
                    profile?.searchProfileUrl || profile?.profileUrl,
                    "_blank",
                  );
                },
                "Link do perfil",
                <OpenInNewIcon />,
              )}
              {CustomButton(
                () => {
                  window.open(profile?.reviewUrl, "_blank");
                },
                "Link de Avaliação",
                <OpenInNewIcon />,
              )}
              {CustomButtonAux(
                copyMetadata,
                "Copiar Resumo",
                <ContentCopyOutlinedIcon />,
              )}
            </CompanyActions>
            <CompanyCarousel>
              {(profile?.photos?.filter((photo) => photo.type !== "PROFILE")
                .length ?? 0) > 0 ? (
                <StyledCarousel showArrows={false}>
                  {profile?.photos
                    ?.filter((photo) => photo.type !== "PROFILE")
                    .slice(0, 5)
                    .map((photo, index) => (
                      <div key={index}>
                        <img src={photo.photoUrl} alt={`Foto ${index + 1}`} />
                      </div>
                    ))}
                </StyledCarousel>
              ) : (
                <ImagePlaceholder>
                  Adicione imagens no seu perfil para que elas sejam exibidas
                  aqui.
                </ImagePlaceholder>
              )}
            </CompanyCarousel>
          </div>
        </TopDetailsContainerLeft>
        {/* {mobile && (
          <SectionIntro style={{ marginTop: "8vh", marginBottom: "-5vh" }}>
            <span className="title">Aqui estão seus números</span>
            <span className="description">
              Filtre aqui o periodo de tempo para uma melhor experiência de
              análise
            </span>
          </SectionIntro>
        )} */}
        <TopDetailsContainerRight>
          <SliderContainer>
            <Slider
              marks={marks}
              value={val}
              valueLabelDisplay="off"
              min={MIN}
              max={MAX}
              onChange={handleChange}
              step={null}
            />
          </SliderContainer>
          <VerticalCards>
            <VerticalItem>
              <img alt="" src={google} className="icon" />
              <span className="label">{profile?.posts?.length ?? 0}</span>
              <span className="description">Postagens Efetuadas</span>
            </VerticalItem>
            <VerticalItem>
              <img alt="" src={avaliation} className="icon" />
              <span className="label">{profile?.reviews?.length ?? 0}</span>
              <span className="description">Avaliações Adicionais</span>
            </VerticalItem>
          </VerticalCards>
        </TopDetailsContainerRight>
      </TopDetailsContainer>
      <CardsRow>
        <AnalyticsCard
          icon={calls}
          label="Ligações"
          value={profile?.analytics?.callClicks ?? 0}
          variation={callsVariation}
        />
        <AnalyticsCard
          icon={access}
          label="Acessos no site"
          value={profile?.analytics?.websiteClicks ?? 0}
          variation={accessVariation}
        />
        <AnalyticsCard
          icon={map}
          label="Views no mapa"
          value={profile?.analytics?.viewsInMap ?? 0}
          variation={mapViewsVariation}
        />
        <AnalyticsCard
          icon={routes}
          label="Rotas Requisitadas"
          value={profile?.analytics?.requestedRoutes ?? 0}
          variation={routesVariation}
        />
      </CardsRow>
      <GraphicsContainer>
        <GraphicsCard>
          <span className="top-title">Visualizações</span>
          <div className="info-container">
            <div className="left-data">
              <span className="top-data">{viewsCount}</span>
              <span className="data-description">{viewLabel}</span>
            </div>
            {viewsVariation !== undefined && viewsVariation > 0 && (
              <div className="right-data">
                <TrendingUpOutlinedIcon sx={{ color: "#0F9D58" }} />
                <span
                  className="trend-value"
                  style={{ color: "#0F9D58", fontFamily: "Roboto" }}
                >
                  {viewsVariation}%
                </span>
              </div>
            )}
          </div>
          <div className="graphic">
            <Line data={data} options={options} />
          </div>
          <div className="bottom-row">
            <BtnSmall onClick={handleDesktop}>Computador</BtnSmall>
            <BtnSmall onClick={handleMobile}>Mobile</BtnSmall>
          </div>
        </GraphicsCard>

        <GraphicsCard>
          <span className="top-title">Cliques no site, Ligações e Rotas</span>
          <div className="info-container">
            <div className="left-data">
              <span className="top-data">{clicksCount}</span>
              <span className="data-description">{clicksLabel}</span>
            </div>
            {clicksVariation !== undefined && clicksVariation > 0 && (
              <div className="right-data">
                <TrendingUpOutlinedIcon sx={{ color: "#0F9D58" }} />
                <span
                  className="trend-value"
                  style={{ color: "#0F9D58", fontFamily: "Roboto" }}
                >
                  {clicksVariation}%
                </span>
              </div>
            )}
          </div>
          <div className="graphic">
            <Line data={clicksChartData} options={options} />
          </div>
          <div className="bottom-row">
            <BtnSmall onClick={handleCalls}>Ligações</BtnSmall>
            <BtnSmall onClick={handleWebsite}>Site</BtnSmall>
            <BtnSmall onClick={handleDirections}>Rotas</BtnSmall>
          </div>
        </GraphicsCard>
      </GraphicsContainer>
      <SectionIntro style={{ marginTop: "0px" }}>
        <span className="title">Ranking Principal de pesquisa</span>
        <span className="description">
          Confira as palavras que nossa inteligência interna está trabalhando
          para crescer o seu perfil.
        </span>
        <div className="action">
          {CustomButtonAux(
            handleCopySummary,
            "Copiar Resumo",
            <ContentCopyOutlinedIcon />,
          )}
        </div>
      </SectionIntro>
      {profile?.rankingSync?.running && (
        <Box
          sx={{
            width: "100%",
            maxWidth: 640,
            mx: "auto",
            mb: 2,
            px: 2,
            py: 1.5,
            borderRadius: 2,
            backgroundColor: "rgba(66, 128, 239, 0.08)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 0.75,
              color: theme.colors.blue.primary,
              fontFamily: "Roboto",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            <TrendingUpOutlinedIcon fontSize="small" />
            Estamos pesquisando suas palavras-chave em tempo real…
          </Box>
          <LinearProgress
            variant="determinate"
            value={
              computeSyncProgress(
                profile.rankingSync.total,
                profile.rankingSync.pending,
              ).pct
            }
            sx={{ height: 8, borderRadius: 4, mb: 0.75 }}
          />
          <Box
            sx={{
              fontFamily: "Roboto",
              fontSize: 13,
              color: "text.secondary",
            }}
          >
            {formatSyncProgress(
              computeSyncProgress(
                profile.rankingSync.total,
                profile.rankingSync.pending,
              ),
            )}
          </Box>
        </Box>
      )}
      <RankedKeyWords>
        <span className="title">Frases chave ranqueadas</span>
        <ContentConditional.NoData
          isData={!!profile?.keywords?.length}
          title="Sem palavras-chave"
          description="Nenhuma palavra-chave principal encontrada no período."
          height="auto"
        >
          <Table>
            {!mobile && (
              <Row>
                <DescriptionTop style={{ marginLeft: "2vw" }}>
                  Palavra chave
                </DescriptionTop>
                <DescriptionTop style={{ textAlignLast: "center" }}>
                  Posição
                </DescriptionTop>
              </Row>
            )}
              {(() => {
                const grupos = agruparPalavras(profile?.keywords ?? []);
                const linha = (item: IKeyword, index: number) => (
                <Row key={index}>
                  <Image src={google} alt="" />
                  <Description>{item.title}</Description>
                  <TableDataRow>
                    {mobile ? (
                      <>
                        <Balloon
                          color={
                            rankingExibido(item) >= 1 && rankingExibido(item) <= 3
                              ? balloonColors[rankingExibido(item)]
                              : "#4280EF"
                          }
                          style={{
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            display: "flex",
                            fontSize:
                              rankingExibido(item) >= 1 &&
                              rankingExibido(item) <= 3
                                ? "15px"
                                : mobile
                                  ? "12px"
                                  : "14px",
                          }}
                        >
                          {textoDaPosicao(item, mobile)}
                        </Balloon>
                        {textoDaMedicao(item) && (
                          <span style={{ color: "#9ca3af", fontSize: mobile ? "10px" : "11px", whiteSpace: "nowrap", fontStyle: "italic" }}>
                            {textoDaMedicao(item)}
                          </span>
                        )}
                        {textoDoMaps(item) && (
                          <span style={{ color: "#6b7280", fontSize: mobile ? "10px" : "12px", whiteSpace: "nowrap" }}>
                            {textoDoMaps(item)}
                          </span>
                        )}
                        <RankingLink href={linkDaConsulta(item)} compact />
                      </>
                    ) : (
                      <>
                        {rankingExibido(item) >= 1 &&
                        rankingExibido(item) <= 3 ? (
                          <Balloon
                            color={balloonColors[rankingExibido(item)]}
                            style={{ fontSize: "15px" }}
                          >
                            {textoDaPosicao(item, mobile)}
                          </Balloon>
                        ) : (
                          <Balloon
                            color={"#4280EF"}
                            style={{ fontSize: mobile ? "11px" : "14px" }}
                          >
                            {textoDaPosicao(item, mobile)}
                          </Balloon>
                        )}
                        {textoDaMedicao(item) && (
                          <span style={{ color: "#9ca3af", fontSize: mobile ? "10px" : "11px", whiteSpace: "nowrap", fontStyle: "italic" }}>
                            {textoDaMedicao(item)}
                          </span>
                        )}
                        {textoDoMaps(item) && (
                          <span style={{ color: "#6b7280", fontSize: mobile ? "10px" : "12px", whiteSpace: "nowrap" }}>
                            {textoDoMaps(item)}
                          </span>
                        )}
                        <RankingLink href={linkDaConsulta(item)} compact />
                        {/* {CustomButton(
                          () => {
                            if (item.searchUrl) {
                              console.log(item);

                              // window.open(item.searchUrl, "_blank");
                            }
                          },
                          "Ver Link",
                          <OpenInNewIcon />,
                          // item.searchUrl ?? ""
                        )} */}
                      </>
                    )}
                  </TableDataRow>
                </Row>
                );
                const secao = (
                  titulo: string,
                  lista: IKeyword[],
                  aviso?: string,
                ) =>
                  lista.length === 0 ? null : (
                    <div key={titulo} style={{ marginBottom: "18px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                          padding: "14px 0 6px 2vw",
                          borderBottom: "1px solid #edf2f7",
                          marginBottom: "4px",
                        }}
                      >
                        <span style={{ fontWeight: 700, fontSize: mobile ? "14px" : "16px" }}>
                          {titulo}
                        </span>
                        <span style={{ color: "#718096", fontSize: "13px" }}>
                          {lista.length}
                        </span>
                      </div>
                      {aviso && (
                        <div
                          style={{
                            color: "#718096",
                            fontSize: "12px",
                            padding: "0 2vw 8px",
                          }}
                        >
                          {aviso}
                        </div>
                      )}
                      {lista.map(linha)}
                    </div>
                  );
                return (
                  <>
                    {secao("No topo do Google", grupos.topo)}
                    {secao("Em evolução", grupos.evoluindo)}
                    {secao(
                      "Medições anteriores",
                      grupos.antigas,
                      "Posições apuradas há mais de 30 dias. Serão atualizadas nas próximas verificações.",
                    )}
                  </>
                );
              })()}
          </Table>
        </ContentConditional.NoData>
      </RankedKeyWords>
      <RankedKeyWords>
        <span className="title">Frases chave extras ranqueadas</span>
        <ContentConditional.NoData
          isData={!!profile?.extraKeywords?.length}
          title="Sem palavras-chave extras"
          description="Nenhuma palavra-chave extra encontrada no período."
          height="auto"
        >
          <Table>
            {!mobile && (
              <Row>
                <DescriptionTop style={{ marginLeft: "2vw" }}>
                  Palavra chave
                </DescriptionTop>
                <DescriptionTop style={{ textAlignLast: "center" }}>
                  Posição
                </DescriptionTop>
              </Row>
            )}
            {profile?.extraKeywords
              ?.slice()
              .sort((a, b) => {
                if (rankingExibido(a) === 0) return 1;
                if (rankingExibido(b) === 0) return -1;
                return rankingExibido(a) - rankingExibido(b);
              })
              .map((item, index) => (
                <Row key={index}>
                  <Image src={google} alt="" />
                  <Description>{item.title}</Description>
                  <TableDataRow>
                    {mobile ? (
                      <>
                        <Balloon
                          color={
                            rankingExibido(item) >= 1 && rankingExibido(item) <= 3
                              ? balloonColors[rankingExibido(item)]
                              : "#4280EF"
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            fontSize:
                              rankingExibido(item) >= 1 &&
                              rankingExibido(item) <= 3
                                ? "15px"
                                : "11px",
                          }}
                        >
                          <span>
                            {textoDaPosicao(item, mobile)}
                          </span>
                        </Balloon>
                        {textoDaMedicao(item) && (
                          <span style={{ color: "#9ca3af", fontSize: mobile ? "10px" : "11px", whiteSpace: "nowrap", fontStyle: "italic" }}>
                            {textoDaMedicao(item)}
                          </span>
                        )}
                        {textoDoMaps(item) && (
                          <span style={{ color: "#6b7280", fontSize: mobile ? "10px" : "12px", whiteSpace: "nowrap" }}>
                            {textoDoMaps(item)}
                          </span>
                        )}
                        <RankingLink href={linkDaConsulta(item)} compact />
                      </>
                    ) : (
                      <>
                        {rankingExibido(item) >= 1 &&
                        rankingExibido(item) <= 3 ? (
                          <Balloon
                            color={balloonColors[rankingExibido(item)]}
                            style={{ fontSize: "15px" }}
                          >
                            {textoDaPosicao(item, mobile)}
                          </Balloon>
                        ) : (
                          <Balloon
                            color={"#4280EF"}
                            style={{ fontSize: mobile ? "11px" : "14px" }}
                          >
                            {textoDaPosicao(item, mobile)}
                          </Balloon>
                        )}
                        {textoDaMedicao(item) && (
                          <span style={{ color: "#9ca3af", fontSize: mobile ? "10px" : "11px", whiteSpace: "nowrap", fontStyle: "italic" }}>
                            {textoDaMedicao(item)}
                          </span>
                        )}
                        {textoDoMaps(item) && (
                          <span style={{ color: "#6b7280", fontSize: mobile ? "10px" : "12px", whiteSpace: "nowrap" }}>
                            {textoDoMaps(item)}
                          </span>
                        )}
                        <RankingLink href={linkDaConsulta(item)} compact />
                      </>
                    )}
                  </TableDataRow>
                </Row>
              ))}
          </Table>
        </ContentConditional.NoData>
      </RankedKeyWords>
      <SectionIntro>
        <span className="title">Interações com a empresa</span>
        <span className="description">
          Ações realizadas pelos clientes ao interagir com a sua empresa
        </span>
      </SectionIntro>
      <InteractionsContainer>
        <MainAvaliationContainer>
          <span className="title">Principais Avaliações do Perfil</span>
          <div className="data-container">
            {profile?.reviews?.map((item, index) => (
              <AvaliationItem key={index}>
                <Avatar
                  alt="Remy Sharp"
                  src={item.profilePhotoUserName}
                  sx={{ width: 56, height: 56 }}
                />
                <div className="details">
                  <div className="title-avaliation">
                    <span>{item.userName} - </span>
                    <span>{parseDate(item.createdTime)}</span>
                  </div>
                  <span className="description">{item.comment}</span>
                </div>
                <div className="rating-container">
                  <Rating
                    name="half-rating"
                    defaultValue={parseEvaluation(item.starRating)}
                    precision={0.5}
                    readOnly
                  />
                </div>
              </AvaliationItem>
            ))}
          </div>
        </MainAvaliationContainer>
        <RemainSearch>
          <span className="title">Demais pesquisas em que apareceu</span>
          <div
            className="data-container"
            style={{
              marginBottom: "40px",
            }}
          >
            <ContentConditional.NoData
              isData={!!profile?.keywordsGoogleAnalytics?.length}
              title="Sem informações"
              description="Nenhuma pesquisa extra encontrada no período."
              height="100%"
            >
              {profile?.keywordsGoogleAnalytics
                ?.slice() // Cria uma cópia para não mutar o estado original
                .sort(
                  (a, b) =>
                    b.approximatelySearchedCount - a.approximatelySearchedCount,
                )
                .map((item, index) => (
                  <RemainSearchItem key={index}>
                    <span className="remain-title">{item.searchkeyword}</span>
                    <span className="remain-position">{index + 1}°</span>
                  </RemainSearchItem>
                ))}
            </ContentConditional.NoData>
          </div>
          <div
            style={{
              backgroundColor: theme.colors.blue.primary,
              borderRadius: "52px",
              height: "35px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              fontFamily: "roboto",
              width: "100%",
              paddingInline: mobile ? "4.5vw" : "1.5vw",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              color: "white",
              marginTop: "auto",
            }}
            onClick={() => {
              navigate(`/reports/keywords/${profileId}`);
            }}
          >
            Ver mais
          </div>
        </RemainSearch>
      </InteractionsContainer>
      {profileId && <SearchTermsGrowth profileId={profileId} />}
      <SectionIntro>
        <span className="title">Últimas postagens efetuadas</span>
        <span className="description">
          Confira as últimas postagens efetuadas pelo nosso sistema de
          ranqueamento
        </span>
        <div className="action">
          {CustomButton(handleClick1, "Ver Link", <OpenInNewIcon />)}
        </div>
      </SectionIntro>
      <PostContainer>
        <div className="data-container">
          {profile?.posts?.map((item, index) => (
            <PostItem key={index}>
              <img src={item.mediaUrl[0]} alt="" className="image-post" />
              <span className="post-title">
                Data da Postagem: {parseDate(item.createTime)}
              </span>
              <span className="post-description">
                {item.summary.length > 180 ? (
                  <>
                    {`${item.summary.substring(0, 180)}... `}
                    <a
                      href={item.searchUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: theme.colors.blue.primary,
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      ver mais...
                    </a>
                  </>
                ) : (
                  item.summary
                )}
              </span>
              <div className="post-btn">
                {CustomButton(
                  () => {
                    window.open(item.searchUrl, "_blank");
                  },
                  "Ver Post",
                  <OpenInNewIcon />,
                )}
              </div>
            </PostItem>
          ))}
        </div>
      </PostContainer>
    </Container>
  );
};

export interface IMonthlyData {
  [key: string]: number; // Index signature for string keys
}

export interface IClicksData {
  [key: string]: IMonthlyData;
}
